/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-08 16:42:08
 */
export default {
  lang: "en",
  common: {
    name1: "Create Card",
    name2: "Ranking List",
    name3: "Share & Get Likes",
    name4: "You've Got XX Likes",
    name5: "You're the top x now, Keep going!",
    name6: "Get More Likes",
    name7: "Submit your information",
    name8: "Name",
    name9: "Phone",
    name10: "Country",
    name11: "Save",
    name12: "",
    name13:"Write Your Own Blessing First",
    name14:"Limited to 230 characters",
    name15:"Don't forget to submit your info to win the gifts",
    name16:"1.Write Greetings to your friends and share to get likes",
    name17:"2.If you get the most likes，you'll win iPhone 12 mini~",
    name18:"3.If you are in TOP 100，you'll also obtain one gift.",
    name19:"Merry Christmas--Bless To Win iPhone",
    name20:"Pick one card you like",
    name21:"Title",
    name22:"Prompt",
  },
  rules: {
    name1: "Phone 12 Mini",
    name2: "Airtime",
    name3: "1Gb",
    name4: "100Mb",
    name5: "Gifts",
    name6: "How to Participate:",
    name7: "1.Pick one card you like & write greetings on it ",
    name8: "2.Share the card to your friends to like it",
    name9: "3.Who get the most likes will win iPhone 12 Mini.",
    name10: "4.If you are in TOP 100，you'll also obtain one gift.",
    name11: "Ranking List",
    name12: "Gifts List",
    name13:"TOP1",
    name14:"iPhone 12 Mini（64G）",
    name15:"Top 2-Top 10",
    name16:"",
    name17:"Top 11-Top 50",
    name18:"1Gb",
    name19:"Top 51-Top 100",
    name20:"100Mb",
    name21:"Note:",
    name22:"1.Only Carlcare accounts can participate,if you are not, pls register first.",
    name23:"2.If you successfully obtain the gifts, please submit your info within activity period, otherwise, the gifts will be cancelled.",
    name24:"3.If you have any problems,pls contact us：Carlcarelucky@gmail.com .",
    name25:"4.Carlcare reserves the right of final interpretation.",
    name26:"Merry Christmas Bless To Win iPhone",
    name27:"Merry Christmas ",
    name28:"Activity Rule",
    name29:"OK",
    name30:"Upgrade",
    name31:"upgrade to enjoy the activity:)",
    name32:"Login",
    name33:"Please log in first",
    name34:"GAME OVER",
    name35:"You've Got ",
    name36:"Likes",
    name37:"My Blessings",
    name38:"Get",
    name39:"Rank",
    name40:"ID",
    name41:"Rules",
    name42:"You're the top",
    name43:"now,keep going!!",
    name44:"Card",
    name45:"Kindly fill in the complete info",
    name46:"You have successfully submitted the information",
    name47:"Merry Christmas-Get likes to win iPhone 12",
  },
};